module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChFront",
    attrs: {
      "id": "frontmatter02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Guerrilla Marketing and Facebook")]), _vm._v(" make great natural partners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They are both leaders: Guerrilla marketing is adopted and followed in many marketing strategies of businesses. No one can deny Facebook’s presence. Facebook is irrefutably recognised as the leading social media tool, with some 955 million users.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They operate with the same principles: Guerrillas want the same thing everybody wants – but they don’t have the same means, or they don’t believe in excessive marketing budgets. So instead of splashing out on big budgets to net profits, Guerrillas’ prime investments are time, energy, imagination and information. Facebook, like any other business, is driven to make profits. But they don’t make their profits from getting people to sign up for Facebook accounts. Facebook’s tagline sums it best: “It’s Free and Will Always Be”. Anybody and everybody above the age of 13 can sign up for a free, lifetime Facebook account.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They operate from the same premise: they recognize that their customers are active participants. The core of Facebook revolves around relationships. The basis of a Guerrilla Facebook "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("Marketing process is centred upon growing a relationship with the customer first.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Born out of this great natural partnership is our main reason why we are driven to write a book on Guerrilla Facebook Marketing, despite the fact that there have been precedents such as Guerrilla Social Media Marketing and Guerrilla Marketing on the Internet. There is just so much synergy between Facebook and Guerrilla Marketing that we find extremely hard to dismiss or ignore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is the result of our journey of uncovering this great natural partnership between Facebook and Guerrilla Marketing. This book is going to stretch your mind with guerrilla marketing possibilities that any business can learn to adopt and apply. From Guerrilla basics such as attitudes and attitudes of a Guerrilla Facebook Marketer ("), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(") to Facebook basics such as Facebook trends and statistics ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v("), to understanding the Rules of Engagement in Facebook for guerrillas ("), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")]), _vm._v("), we have the bases covered. We guerrillas always enter into battle with a plan, so we prepare for it by selecting weapons – in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(", there are 25 Facebook-specific weapons for you to choose from before you go on to create your Guerrilla Facebook Marketing plan and calendar in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")]), _vm._v(". After you have launched your plan, we take it a notch higher by suggesting ways to refine your plan by making sense of your investments in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(". By the time you are ready to fly into "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(", we invite you to take your Guerrilla Facebook Marketing plan to the skies, by examining how your Guerrilla Facebook Marketing efforts faceoff with your online marketing efforts. The glossary on Facebook and Guerrilla Marketing concepts at the end of this book serves as a useful future reference point.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though this is a book, we see you, our reader, as an active participant in the book reading process. We have provided you "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("with white space and exercises in this book for you to get actively involved in the reading process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We wish you many happy hours connecting with your customers on Facebook that lead to profit generation for your business!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("See you on Facebook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('strong', [_vm._v("Jay Levinson")]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336888be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter02.vue
// module id = 78
// module chunks = 0